import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router';

export function Layout() {
  return (
    <Flex direction="column" minH="100vh">
      <Box as="main" flex="1">
        <Outlet />
      </Box>
    </Flex>
  );
}
